export default __webpack_public_path__ + "static/media/category_icon.72ddd7d6.svg";